<template>

  <Dialog :header="header"
          class="ticket-dialog"
          v-model:visible="computedVisible"
          :modal="true"
          :closable="true"
          :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '30vw'}">

    <template #header>
      <h3>Perfil de Usuario {{ getUserRoles[user.role_id] }}</h3>
    </template>

    <ProfileLabel title="Name" :content="user.name"/>
    <ProfileLabel title="Correo Electrónico" :content="user.email" />
    <ProfileLabel title="Nivel de acceso" :content="getUserRoles(user.role_id)"/>
    <ProfileLabel title="Estatus" :content="getUserStatus(user.status_id)"/>
    <ProfileLabel title="Último acceso" :content="formatDateAndtime(user.lastLoginAt)"/>
    <ProfileLabel title="Fecha de creación" :content="formatDate(user.createdAt)"/>

  </Dialog>
</template>

<script>
import ProfileLabel from "@/components/misc/Labels/ProfileLabel";
import generalMixin from "@/mixins/generalMixin";

export default {
  name: "Profile",
  mixins: [generalMixin],
  components: {
    'ProfileLabel': ProfileLabel,
  },
  props: {
    show: Boolean,
    header: String,
  },
  data() {
    return {
      displayTicket: false,
      particular: null,
      overlay: false,
      user: null,
    }
  },
  mounted() {
    this.user = this.$store.getters.getProfile;
  },
  methods: {
    closeVProfileDialog() {
      this.displayTicket = false;
      this.overlay = false;
    }
  },
  computed: {
    computedVisible: {
      get() {
        return this.show
      },
      set() {
        this.$emit('close')
      }
    },
    getTicketNumber() {
      return this.header;
    },
  },
}
</script>

<style scoped lang="scss">

Label2 {
  .title {
    width: 200px !important;
  }
}
</style>